<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'60px'"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('settingZones.header.province')" prop="provinceId">
            <BjSelectChinaArea
              v-model="queryParams.provinceId"
              all
              clearable
              class="full-width"
              @change="changeProvince"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('settingZones.header.city')" prop="cityId">
            <BjSelectChinaArea
              v-model="queryParams.cityId"
              type="city"
              all
              class="full-width"
              :parent-code="queryParams.provinceId"
              :disabled="!queryParams.provinceId"
              @change="queryParams.areaId = null"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('settingZones.header.district')" prop="areaId">
            <BjSelectChinaArea
              v-model="queryParams.areaId"
              type="area"
              all
              class="full-width"
              :disabled="!(queryParams.provinceId && queryParams.cityId)"
              :parent-code="queryParams.cityId"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="enabledFlag">
            <BjSelectLov v-model="queryParams.enabledFlag" :option-list="STATUS_ENABLED_TRUE" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            v-permission:SettingLogisticsStrategyZonesIndex_Delete
            :disabled="tableOperationProp.notSelected"
            type="primary"
            @click="onDeleteSelected"
            >{{ $t('delText') }}</el-button
          >
          <el-button
            v-permission:SettingLogisticsStrategyZonesIndex_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('addText') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
            :show-overflow-tooltip="col.prop !== 'bjTableAction'"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'amountStart'">
                {{ scope.row.amountStart }} ~ {{ scope.row.amountEnd }}
              </template>
              <template v-else-if="col.prop === 'enabledFlag'">
                <el-tag :type="scope.row[col.prop] ? 'success' : 'info'">{{
                  $t(STATUS_ENABLED_TRUE.bjGet(scope.row[col.prop]))
                }}</el-tag>
              </template>
              <!-- <template v-else-if="['provinceId', 'cityId', 'areaId'].indexOf(col.prop) !== -1">
                {{ scope.row[col.prop] === 0 ? '全部' : scope.row }}
              </template> -->
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:SettingLogisticsStrategyZonesIndex_Edit
                type="text"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-if="!props.row.enabledFlag"
                v-permission:SettingLogisticsStrategyZonesIndex_Status
                type="text"
                @click="onStatus(true, props.row)"
                >{{ $t('enableText') }}</el-button
              >
              <el-button
                v-else
                v-permission:SettingLogisticsStrategyZonesIndex_Status
                type="text"
                @click="onStatus(false, props.row)"
                >{{ $t('disableText') }}</el-button
              >
              <el-button
                v-permission:SettingLogisticsStrategyZonesIndex_Delete
                type="text"
                @click="onDelete(props.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增弹窗 -->
    <DataForm ref="DataForm" :disabled-list="disabledList" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { settingApi } from '@/api';
import DataForm from './components/DataForm.vue';
import { STATUS_ENABLED_TRUE } from '@/utils/constants';
const getDefaultForm = () => {
  return {};
};
export default {
  name: 'SettingLogisticsStrategyZonesIndex',
  components: { DataForm },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_TRUE,
      queryApi: settingApi.getStrategyZones, // settingApi.getStockProcess,
      colSpan: 6,
      // 查询参数
      queryParams: {
        provinceId: null,
        cityId: null,
        areaId: null,
      },
      title: '',
      dialogVisible: false,
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},
      labelsVersion: 11,
      labelList: [
        { label: 'settingZones.table.province', prop: 'provinceName', isCheck: true, disabled: false },
        { label: 'settingZones.table.city', prop: 'cityName', isCheck: true, disabled: false },
        { label: 'settingZones.table.district', prop: 'areaName', isCheck: true, disabled: false },
        { label: 'settingZones.table.logistics', prop: 'logisticCompanyName', isCheck: true, disabled: false, width: 150 },
        { label: 'settingZones.table.logisticsBusiness', prop: 'logisticBusinessName', isCheck: true, disabled: false, width: 210 },
        { label: 'table.statusText', prop: 'enabledFlag', isCheck: true, disabled: false },
        { label: 'table.creatorText', prop: 'createdName', isCheck: true, disabled: false, width: 135 },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: 135 },
        { label: 'settingZones.table.updater', prop: 'lastUpdatedName', isCheck: true, disabled: false, width: 135 },
        {
          label: 'settingZones.table.lastUpdated',
          prop: 'lastUpdateDate',
          isCheck: true,
          disabled: false,
          width: 135,
        },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 165 },
      ],
      disabledList: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      return new Promise(resolve => {
        resolve();
      });
    },
    // beforeQuerySearch(conditionObj) {
    //   return new Promise(resolve => {
    //     let v = conditionObj.provinceId;
    //     conditionObj.provinceId = v === 0 ? '' : v;
    //     v = conditionObj.cityId;
    //     conditionObj.cityId = v == 0 ? '' : v;
    //     v = conditionObj.areaId;
    //     conditionObj.areaId = v == 0 ? '' : v;
    //     resolve(conditionObj);
    //   });
    // },
    changeProvince() {
      this.queryParams.cityId = this.queryParams.areaId = null;
    },
    /** 创建 */
    onAdd() {
      this.getHasSetArea().then(res => {
        this.$refs.DataForm.show();
      });
    },
    onEdit(row) {
      this.$refs.DataForm.show(row);
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_TRUE.bjGet(flag));
      this.$confirm(
        `${this.$t('toast.youAreTipText')} ${TEXT} ${row.provinceName}${row.cityName}${row.areaName}，${this.$t('toast.continueTipText')}`,
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        },
      )
        .then(() => {
          const data = this.$lodash.clone(row);
          data.enabledFlag = flag;
          this.operationApi(data);
        })
        .catch(() => {});
    },
    /** 删除 */
    onDelete(row) {
      this.$confirm(
        `${this.$t('toast.youAreDelTipText')} ${row.provinceName}${row.cityName}${row.areaName}，${this.$t('toast.continueTipText')}`,
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        },
      )
        .then(() => {
          this.batchDeleteApi({ ids: [row.id] });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => e.enabledFlag == true)) {
        this.$message.warning(this.$t('toast.delEnabledTipText'));
        return;
      }

      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    getHasSetArea() {
      return new Promise((resolve, reject) => {
        settingApi.getStrategyZonesHasSetArea().then(res => {
          this.disabledList = res;
          resolve(res);
        });
      });
    },
    operationApi(API_DATA) {
      settingApi.updateStrategyZones(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      settingApi.deleteStrategyZones(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
